import { MutationTree } from "vuex";
import { UserState, SET_USER, SetUser } from "./types";

export const mutations: MutationTree<UserState> = {
  [SET_USER](state, input: SetUser) {
    state.user = input.user;
  },
};
